import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useBoardPermissions from '../../common/hooks/useBoardPermissions';
import {
  openBoardCardFromColumnClick,
  openFormMapDrawer,
  openShortListDrawer,
  getShortLists,
  getFormMappings,
} from '../state/boards.actions';

export default function useBoardCardFromColumn() {
  const dispatch = useDispatch();
  const [selectedBoardId, setSelectedBoardId] = useState(null);

  const boards = useSelector((state) => state.boards.boards);
  const cardTemplates = useSelector((state) => state.boards.cardTemplates);
  const boardPermissionsUsers = useSelector((state) => state.boards.boardPermissionsUsers);

  const ourBoard = useMemo(
    () => boards[selectedBoardId],
    [boards, selectedBoardId],
  );
  const cardType = useMemo(
    () => cardTemplates[ourBoard?.cardTypeId],
    [ourBoard, cardTemplates],
  );
  const userBoardPermissions = useBoardPermissions({
    users: boardPermissionsUsers,
    creatorId: ourBoard?.creatorId,
  });

  const onForm = useCallback((cardId) => {
    dispatch(openFormMapDrawer({ selectedCardId: cardId }));
  }, [dispatch]);

  const onShortList = useCallback((cardId) => {
    dispatch(openShortListDrawer({ selectedCardId: cardId }));
    dispatch(getShortLists());
  }, [dispatch]);

  const onCardColumnClick = useCallback(({ cardId, boardId } = {}) => {
    if (!cardId || !boardId) return;
    setSelectedBoardId(boardId);
    dispatch(openBoardCardFromColumnClick({
      cardId,
      boardId,
      onForm,
      onShortList,
      isLocked: boards[boardId]?.isLocked,
    }));
  }, [dispatch, onForm, onShortList, boards]);

  const onBoardDrawerClose = useCallback(() => {
    setSelectedBoardId(null);
  }, []);

  useEffect(() => {
    if (selectedBoardId) dispatch(getFormMappings(selectedBoardId));
  }, [selectedBoardId, dispatch]);

  return {
    selectedBoardId,
    ourBoard,
    cardType,
    userBoardPermissions,
    onCardColumnClick,
    onBoardDrawerClose,
  };
}
